/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios'

/**
 * 错误提示弹出层
 */
const tip = (msg) => {
  window.utils.Message.error(msg)
}
/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
// const toLogin = () => {
//   Vue.$router.push('/login')
// }

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status) => {
  // 状态码判断
  switch (status) {
    // case 400:
    //   //tip('用户名或密码错误', 1)
    //   break
    case 401:
      tip('登录失效')
      break
    // 403 token过期
    // 清除token并跳转登录页
    case 403:
      tip('没有访问权限')
      break
    // 404请求不存在
    case 404:
      tip('请求的资源不存在')
      break
    case 500:
      tip('服务器异常')
      break
    default:
      break
  }
}

// 创建axios实例
var instance = axios.create({timeout: 1000 * 60})

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  (config) => {
    config.headers['Visit-Type'] = 'web'

    // 登录流程控制中，根据本地是否存在token判断用户的登录情况
    return config
  },
  (error) => Promise.error(error)
)

// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  (response) => {
    if (response.data.location) {
      window.location.href = response.data.location
      return
    }
    return response.status === 200
      ? Promise.resolve(response.data)
      : Promise.reject(response.data)
  },
  // 请求失败
  (error) => {
    const {response} = error
    //判断Token是否失效
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response)
      return Promise.reject(error)
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      // store.commit('changeNetwork', false)
    }
  }
)

export default instance
